export const CONTACT_TITLE = 'Get In Touch';
// Note: Email moved to Contact.jsx with obfuscation to prevent spam bots
